import { take } from "redux-saga/effects";
import {
  INewConversationMessage,
  MsgActionType,
} from "../../../types/webchatConversation";
import { WRITE_MESSAGE } from "../constants";

const sendMessage = (
  socket: any,
  type: any,
  text: string,
  action: MsgActionType,
  avatar: string,
  file?: any,
) => {
  const messageData: any = {
    type,
    text,
    action,
    avatar,
  };

  if (file) {
    messageData.file = file;
  }

  socket.emit("send-message", messageData);
};

export function* write(socket) {
  while (true) {
    const {
      payload: { message },
    }: { payload: { message: INewConversationMessage } } = yield take(
      WRITE_MESSAGE,
    );

    const { msg, type } = message;

    const action = MsgActionType.RESPOND;
    const avatar = "";

    sendMessage(socket, type, msg.text || "", action, avatar, msg.file);
  }
}
